import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';
import { deriveIncidences } from 'PDF/TemplateEngine/utils/deriveIncidences';
import EmptyState from 'PDF/TemplateEngine/atoms/EmptyState';
import StatusTag from 'PDF/TemplateEngine/atoms/StatusTag';

// Body type 'incidence-summary': deriva celdas FALLA del dataset y las lista.
function IncidenceSummarySection({ section, data }) {
  const { colors, FONT } = useTemplateColors();
  const cfg = section?.config || {};
  const incidencias = deriveIncidences(data?.[cfg.sourceKey]);

  if (incidencias.length === 0) {
    return (
      <EmptyState
        title="Sin incidencias"
        subtitle="No se detectaron hallazgos que requieran reparación."
      />
    );
  }

  const styles = StyleSheet.create({
    wrap: { border: `1px solid #e7c6c1`, borderRadius: 6, overflow: 'hidden' },
    row: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: '0.2cm',
      padding: '0.2cm 0.25cm',
      borderBottom: '1px solid #f0e0de',
    },
    asc: { fontSize: 9, fontFamily: FONT.bold, color: colors.ink || colors.darkText },
    sec: { fontSize: 7, fontFamily: FONT.base, color: colors.muted },
    det: { flex: 1, fontSize: 8.5, fontFamily: FONT.base, color: colors.muted, lineHeight: 1.4 },
  });

  return (
    <View style={styles.wrap}>
      {incidencias.map((x, i) => {
        const grave = x.severidad === 'ALTA' || x.severidad === 'CRITICA';
        return (
        <View key={i} style={styles.row} wrap={false}>
          <StatusTag tone={grave ? 'err' : 'signal'}>
            {grave ? 'Atención inmediata' : 'Observación'}
          </StatusTag>
          <View style={{ width: '16%' }}>
            <Text style={styles.asc}>{x.asc}</Text>
            <Text style={styles.sec}>{x.sector}</Text>
          </View>
          <Text style={styles.det}>{x.det}</Text>
        </View>
        );
      })}
    </View>
  );
}

export default IncidenceSummarySection;
